function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "external-link",
  d: "M15.564,11.638v3.926a1.57,1.57,0,0,1-1.571,1.571H4.571A1.57,1.57,0,0,1,3,15.564V6.141A1.571,1.571,0,0,1,4.571,4.571H8.5V6.141H4.571v9.423h9.423V11.638Zm0-5.957L9.835,11.408,8.725,10.3l5.727-5.727h-3.6V3h6.282V9.282H15.562Z",
  transform: "translate(-3 -3)",
  fill: "#1dbf73",
  fillRule: "evenodd"
});

function SvgShareSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_67909",
    "data-name": "Group 67909",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.132,
    height: 14.135,
    viewBox: "0 0 14.132 14.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSite);
export default __webpack_public_path__ + "static/media/shareSite.9203006f.svg";
export { ForwardRef as ReactComponent };